import React from 'react'

import Button from '@components/Content/Button/Button'
import PartnersGrid from '@components/Partners/PartnersGrid'
import Section from '@components/Section/Section'
import SectionContent from '@components/Section/SectionContent'
import SectionTitle from '@components/Section/SectionTitle'

import { ButtonType } from '@contracts/Components/Button'
import { PartnersSectionType } from '@contracts/Components/Partners'

import usePartnersArchiveLink from '@hooks/usePartnersArchiveLink'

import * as styles from './PartnersSection.module.scss'

interface Props {
	data: PartnersSectionType
	style: 'default' | 'secondary'
}

const PartnersSection = (props: Props) => {
	const contentStyles = [styles.content]

	if (props.style === 'secondary') {
		contentStyles.push(styles.secondary)
	}

	const buttonData: ButtonType = {
		buttonType: 'internal',
		label: 'View all partners',
		internalLink: {
			link: usePartnersArchiveLink(),
		},
	}

	return (
		<Section type="wide">
			<SectionTitle title={props.data.styledTitle} />
			<SectionContent className={contentStyles.join(' ')}>
				<PartnersGrid partners={props.data.partners} />

				<div className={styles.button}>
					<Button data={buttonData} style="hollow" />
				</div>
			</SectionContent>
		</Section>
	)
}

export default PartnersSection
